<template>
  <v-row class="mx-auto">
    <v-col cols="12">
      <v-card outlined :loading="loading" :disabled="loading">
        <v-card-title class="subtitle-1">{{ dynamicLabel }}</v-card-title>
        <v-card-text v-if="!readonly">
          <div class="d-flex align-center">
            <v-btn class="mr-2" color="primary" @click="clickAddNewLine()"><v-icon left>mdi-plus</v-icon>Selecionar Linha</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      sm="6"
      v-for="(lineSelected, index) in lineSelect"
      :key="index"
    >
      <v-card outlined class="mx-auto">
        <v-card-title class="primary white--text">
          <div class="headerClass">
            {{ lineSelected && lineSelected.ddi ? lineSelected.ddi + ' (' + lineSelected.ddd + ') ' + lineSelected.nr_linha : 'Selecione uma linha' }}
          </div>
          <v-spacer></v-spacer>
          <v-btn v-if="!readonly && lineSelect.length > 1" icon @click="closeLine(index)" class="mx-3 mt-2 white--text">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <LineComponent
                :readonly="readonly"
                :rules="[v => (v && Object.keys(v).length > 0) || 'Obrigatório']"
                :selectedLine="lineSelected"
                :searchParams="lineSearchParams"
                @save="
                  lineSelected = $event;
                  updateSelectedLine($event, index);
                "
              ></LineComponent>

              <v-checkbox
                v-model="lineSelected.configure_sms_block"
                label="Configurar Bloqueio SMS"
                :disabled="readonly"
                hide-details
                class="mt-2"
                @change="onSmsBlockToggle(lineSelected)"
              ></v-checkbox>
              <v-select
                v-if="lineSelected.configure_sms_block"
                :items="smsBlockActions"
                item-text="label"
                item-value="value"
                label="Ação Bloqueio SMS"
                v-model="lineSelected.sms_block_action"
                :disabled="readonly"
                dense
                outlined
                class="mt-2"
                :rules="[v => !!v || 'Selecione uma ação de bloqueio SMS']"
                @change="updateValues(lineSelect)"
              ></v-select>

              <v-checkbox
                v-model="lineSelected.configure_manager_block"
                label="Configurar Bloqueio Gestor"
                :disabled="readonly"
                hide-details
                class="mt-4"
                @change="onManagerBlockToggle(lineSelected)"
              ></v-checkbox>
              <v-select
                v-if="lineSelected.configure_manager_block"
                :items="managerBlockActions"
                item-text="label"
                item-value="value"
                label="Ação Bloqueio Gestor"
                v-model="lineSelected.manager_block_action"
                :disabled="readonly"
                dense
                outlined
                class="mt-2"
                :rules="[v => !!v || 'Selecione uma ação de bloqueio gestor']"
                @change="updateValues(lineSelect)"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import LineComponent from "@/components/forms/LineComponent.vue";
import isEmpty from "lodash/isEmpty";
import { VIVO } from "../../helpers/constants";

const SMS_BLOCK_ACTIONS = [
  { label: "Ativar Bloqueio", value: "activate" },
  { label: "Desativar Bloqueio", value: "deactivate" },
];

const MANAGER_BLOCK_ACTIONS = [
  { label: "Bloquear", value: "block" },
  { label: "Desbloquear", value: "unblock" },
];

export default {
  components: { LineComponent },
  props: {
    index: {},
    groupUser: {},
    uniqueKeyStorage: {
      type: String,
      default: ""
    },
    page: {
      type: String,
      default: ""
    },
    readonly: {
      type: Boolean,
      default: false
    },
    defaultValues: {
      type: Array,
      default: () => []
    },
    field: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      lineSelect: [],
      loading: true,
      maxLength: 50,
      dynamicLabel: "Bloqueio de Voz e Dados Vivo (Automática)",
      resultStorage: null,
      smsBlockActions: SMS_BLOCK_ACTIONS,
      managerBlockActions: MANAGER_BLOCK_ACTIONS,
      lineSearchParams: { id_operadora: VIVO },
    };
  },
  async mounted() {
    try {
      if (this.page === "interaction") {
        this.readonly = true;
        if (this.field?.label) {
          this.dynamicLabel = this.field.label;
        }
        this.lineSelect = this.field.values || this.field.lines || [];
        await this.updateValues();
      }
      if (this.page === "validate") {
        this.$emit("componentLoading", true);
      }

      if (this.page === "wizard") {
        if (this.wizard.model["block_voice_data_vivo"]) {
          this.wizard.forms.map(form => {
            if (form.type === "block_voice_data_vivo") {
              this.dynamicLabel = form.label;
            }
          });
        }

        this.lineSelect = [...this.lineSelect, {}];

        const dataLocalStorage = await this.loadDataLocalStorage(this.uniqueKeyStorage);
        if (!isEmpty(dataLocalStorage) && this.page === "wizard") {
          this.resultStorage = dataLocalStorage;
          this.lineSelect = Object.assign([], this.resultStorage);
        }
      }

      if (this.defaultValues.length > 0) {
        this.lineSelect = this.defaultValues;
      }

      if (this.page === "validate") {
        await this.updateValues();
        this.$emit("componentLoading", false);
      }
      this.loading = false;
    } finally {
      if (this.page === "validate") {
        this.$emit("fieldReady");
      }
    }
  },
  computed: {
    ...mapState("forms", ["wizard"]),
    ...mapState("solicitation", ["solicitation_validate_values"]),
  },
  methods: {
    ...mapActions("solicitation", ["loadDataLocalStorage", "setAutomationComponentValues"]),
    ...mapActions("interaction", ["setAutomationComponentFields"]),
    ...mapMutations("forms", ["SET_FORM_EMAIL"]),
    ...mapMutations({ setModel: "forms/setModelBlockVoiceDataVivo" }),
    onSmsBlockToggle(lineSelected) {
      if (!lineSelected.configure_sms_block) {
        lineSelected.sms_block_action = null;
      }
      this.updateValues(this.lineSelect);
    },
    onManagerBlockToggle(lineSelected) {
      if (!lineSelected.configure_manager_block) {
        lineSelected.manager_block_action = null;
      }
      this.updateValues(this.lineSelect);
    },
    async clickAddNewLine() {
      if (this.lineSelect.length >= this.maxLength) {
        await this.$swal("Limite máximo atingido", "O número máximo de cards dessa solicitação é " + this.maxLength + ".", "info");
      } else {
        this.lineSelect = [{}, ...this.lineSelect];
      }
    },
    async updateSelectedLine(lineSelected, index) {
      const exists = this.lineSelect.some((line, i) => line.id_linha === lineSelected.id_linha && i !== index);

      if (exists) {
        this.lineSelect[index] = {};
        this.lineSelect = Object.assign([], this.lineSelect);
        await this.$swal("Linha já selecionada!", "", "warning");
        return;
      }

      const previous = this.lineSelect[index] || {};
      this.lineSelect[index] = {
        ...lineSelected,
        configure_sms_block: previous.configure_sms_block || false,
        sms_block_action: previous.sms_block_action || null,
        configure_manager_block: previous.configure_manager_block || false,
        manager_block_action: previous.manager_block_action || null,
      };
      this.lineSelect = Object.assign([], this.lineSelect);
      await this.updateValues(this.lineSelect);
    },
    async updateValues(lineList) {
      if (this.page === "validate") {
        await this.setAutomationComponentValues({
          automation: "block_voice_data_vivo",
          data: { block_voice_data_vivo: this.lineSelect }
        });
        this.SET_FORM_EMAIL({});
        this.SET_FORM_EMAIL(this.solicitation_validate_values);
      } else if (this.page === "wizard") {
        const payload = {
          step: this.index,
          selected: lineList
        };
        this.setModel(payload);
        localStorage.setItem(this.uniqueKeyStorage, JSON.stringify(lineList));
      } else if (this.page === "interaction") {
        await this.setAutomationComponentFields({
          automation: "block_voice_data_vivo",
          data: this.lineSelect,
        });
      }
    },
    closeLine(index) {
      if (index > -1) {
        this.lineSelect.splice(index, 1);
      }
      this.updateValues(this.lineSelect);
    },
  }
};
</script>
<style scoped>
.headerClass {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
